import { jsx as _jsx } from "react/jsx-runtime";
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { isTreeStructurePath, isTreeStructureTerminator } from './defaultMenuStructure';
import { handleContextMenu } from '../clickWrappers/helpers';
const debug = process.env.REACT_APP_DEBUG && false;
/** given a TreeDefinitionMap configuration, produces tree instances */
export const instantiateTree = ({ treeDefinitionMap, treeProps, lastKey = '', navigationContext }) => {
    debug && lastKey === '' && console.log(`DEBUG: instantiating tree with:`, treeDefinitionMap, treeProps);
    return Object.entries(treeDefinitionMap).map(([k, v]) => {
        let node = null;
        const thisKey = `${lastKey}_${k}`;
        let contextMenuLabel = null;
        if (v.contextMenuConfig) {
            contextMenuLabel = (v.contextMenuConfig
                ? handleContextMenu(v.label ?? k, v.contextMenuConfig.supportedType, navigationContext)
                : (v.label ?? k));
        }
        if (isTreeStructurePath(v)) {
            //recurse down to bottom, and render the resulting children in TreeItem
            debug && console.log(`${k} is path, has context menu? ${!!contextMenuLabel}`);
            const next = instantiateTree({ treeDefinitionMap: v.next, treeProps, lastKey: thisKey, navigationContext });
            const label = contextMenuLabel ?? v.label ?? k; /// TODO REMOVE ->// v.contextMenuConfig ? handleContextMenu(v.label ?? k, v.contextMenuConfig.supportedType, navigationContext) : v.label ?? k
            node = _jsx(TreeItem, { itemId: thisKey, label: contextMenuLabel ?? label, children: next }, thisKey);
        }
        else if (isTreeStructureTerminator(v)) {
            debug && console.log(`${k} is terminator, has context menu? ${!!v.contextMenuConfig}`);
            const FC = v.treeFC;
            if (v.label) {
                node = _jsx(TreeItem, { itemId: thisKey, label: contextMenuLabel ?? v.label, children: _jsx(FC, { ...treeProps, lastKey: lastKey }) }, thisKey);
            }
            else {
                node = _jsx(FC, { ...treeProps, lastKey: lastKey }, thisKey);
            }
        }
        else {
            debug && console.log(`${k} is not path or terminator`);
            if (k === 'Devices') {
                debug && console.log(`DEVICE CONFIG`, treeDefinitionMap);
            }
            else {
                // nothing to do
            }
            node = _jsx(TreeItem, { itemId: thisKey, label: contextMenuLabel ?? v.label, children: undefined }, thisKey);
        }
        return node;
    });
};
